// You can write more code here

import { DEFAULT_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class UIBlocker extends Phaser.GameObjects.Image {
  constructor(
    scene: Phaser.Scene,
    x?: number,
    y?: number,
    texture?: string,
    frame?: number | string,
  ) {
    super(scene, x ?? 0, y ?? 0, texture || '1x1sprite', frame);

    this.scaleX = 1600;
    this.scaleY = 1024;
    this.setOrigin(0, 0);
    this.alpha = 0.3;
    this.alphaTopLeft = 0.3;
    this.alphaTopRight = 0.3;
    this.alphaBottomLeft = 0.3;
    this.alphaBottomRight = 0.3;
    this.tintTopLeft = 0;
    this.tintTopRight = 0;
    this.tintBottomLeft = 0;
    this.tintBottomRight = 0;

    /* START-USER-CTR-CODE */
    this.setInteractive({ cursor: `${DEFAULT_CURSOR_PATH}, auto` });
    const anchor = this.scene.plugins.get('rexanchorplugin') as any;
    if (!anchor) {
      console.warn('Anchor plugin not loaded!');
      return;
    }
    this.setScale(1600, 1024);
    anchor.add(this, {
      left: '0%',
      top: '0%',
    });
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
